import APIManager from 'api/APIManager';
import APIConstant from 'api/APIConstant';
import { parameterToPath } from 'utils';

export type Tag = {
  tag_id?: number; // 태그 idx
  tag_name?: string; // 태그 명
  is_show?: string; // 노출 여부
  product?: { [key: string]: Record<string, any> }[]; // 상품
  created_at?: number; // 생성일
  updated_at?: number; // 수정일
};

const $http = new APIManager();

const Api = {
  /**
   * [GETS] Tag
   * --
   */
  getTags: async (params?: { [key: string]: string | number }) => {
    try {
      const res = await $http.get(APIConstant.GETS_TAG, params);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [GET] Tag
   * --
   */
  getTag: async (idx: number, params?: { [key: string]: string | number }) => {
    try {
      const url = parameterToPath(APIConstant.GET_TAG, { tag_id: idx });
      const res = await $http.get(url, params);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [POST] Tag
   * --
   */
  createTag: async (body: Tag) => {
    try {
      const res = await $http.post(APIConstant.CREATE_TAG, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [PUT] Tag
   * --
   */
  updateTag: async (body: Tag) => {
    try {
      const { tag_id } = body;
      const url = parameterToPath(APIConstant.UPDATE_TAG, {
        tag_id: tag_id,
      });

      const res = await $http.put(url, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [DELETE] Tag
   * --
   */
  deleteTag: async (idx: number) => {
    try {
      const url = parameterToPath(APIConstant.UPDATE_TAG, {
        tag_id: idx,
      });

      const res = await $http.delete(url);

      return res;
    } catch (e) {
      throw e;
    }
  },
};

export default Api;
